




import { Vue, Component, Prop, Watch, Emit, Ref } from "vue-property-decorator";
import { PaymentType } from "../types/enum/OrderEnum";

interface ColorAndText {
  color: string;
  text: string;
}

@Component
export default class PaymentTypeComponent extends Vue {
  @Prop(Number) type!: PaymentType;

  public get colorAndText(): ColorAndText {
    return this.type === PaymentType.Offline
      ? {
          color: "#009688",
          text: "Pay in store"
        }
      : {
          color: "#00BCD4",
          text: "Online pay"
        };
  }
}
